<template>
  <section class="kp-modular-content">
    <link rel="stylesheet" :href="themeCdnUri + '/bootstrap-box.css'">
    <link rel="stylesheet" :href="themeCdnUri + '/popup.css'">
    <link rel="stylesheet" :href="themeActiveStyles">
    <link rel="stylesheet" v-for="font in boxThemeFonts" :href="font">
    <step v-show="canvasCurrentView === 'steps'"></step>
    <fluxogram></fluxogram>
    <preview v-if="canvasCurrentView === 'preview'"></preview>
    <trigger-button v-show="canvasCurrentView === 'triggerbutton'"></trigger-button>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import Step from './step/Main.vue';
import Fluxogram from './fluxogram/Main.vue';
import Preview from './preview/Main.vue';
import TriggerButton from './triggerbutton/Main.vue';
import rebrand from '../../../config/rebrand';

export default {
  data() {
    return {
      themeCdnUri: rebrand.urls.THEME_CDN_URI,
    };
  },
  components: {
    Step,
    Fluxogram,
    Preview,
    TriggerButton,
  },
  computed: mapGetters({
    canvasCurrentView: 'canvasCurrentView',
    themeActiveStyles: 'themeActiveStyles',
    boxThemeFonts: 'boxThemeFonts',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?0f8012a4
 **/